import { TextArea as SerendieTextArea } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import "./Styles.scss";
import React from "react";
import { components } from "../../Components";

export class TextArea extends BaseComponent<ITextAreaProps, ITextAreaState>
{
    private inputElement: HTMLTextAreaElement | null = null;
    public static requiredLabel = '*';

    private ref(inputElement: HTMLTextAreaElement | null): void
    {
        this.inputElement = inputElement;
        const { ref } = this.props;

        if (typeof ref == 'function')
        {
            ref(inputElement);
        }
        else if (ref)
        {
            ref.current = inputElement;
        }
    }

    public componentDidMount(): void
    {
        this.updateRequiredLabel();
    }

    public componentDidUpdate(): void
    {
        this.updateRequiredLabel();
    }

    private updateRequiredLabel(): void
    {
        const requiredContainer = this.inputElement?.parentElement?.parentElement?.querySelector('label')?.querySelector('span');
        if (!requiredContainer)
        {
            return;
        }
        requiredContainer.innerText = this.props.requiredLabel ?? TextArea.requiredLabel;
    }

    public render(): JSX.Element
    {
        return <SerendieTextArea
            {...this.props}
            ref={e => this.ref(e)}
            className={`${this.props.className ?? ''} serendie-textarea`}
        />
    }
}

export interface ITextAreaProps extends React.ComponentProps<typeof SerendieTextArea>
{
    requiredLabel?: string;
}

export interface ITextAreaState { }
